import { makeStyles } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

import { customTokens } from 'src/utils/theme';

const flexCenter = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const contentMinWidth = {
  minWidth: '375px',
};

export const useDefaultTemplateStyles = makeStyles({
  page: {
    backgroundColor: customTokens.colorNeutralBackground7,
  },
  header: {
    paddingTop: isMobile ? `${customTokens.spacingVerticalL}` : `${customTokens.spacingVerticalNone}`,
  },
  headerContent: {
    width: '100%',
  },
  main: {
    ...flexCenter,
    border: `${customTokens.strokeWidthThin} solid ${customTokens.colorNeutralStrokeSubtle}`,
  },
  mainContent: {
    ...flexCenter,
    ...contentMinWidth,
    width: '70%',
    maxWidth: '900px',
    flexDirection: 'column',
    padding: isMobile
      ? `${customTokens.spacingVerticalXL} ${customTokens.spacingHorizontalL}`
      : `${customTokens.spacingVerticalXL} ${customTokens.spacingHorizontalNone}`,
  },
  preFooter: {
    ...flexCenter,
    backgroundColor: customTokens.colorNeutralBackground2,
  },
  preFooterContent: {
    ...contentMinWidth,
    width: '85%',
    maxWidth: '1070px',
  },
  footer: {
    ...flexCenter,
    backgroundColor: customTokens.colorNeutralBackground1,
  },
  footerContent: {
    ...contentMinWidth,
    width: '85%',
    maxWidth: '1100px',
  },
});
